// import React from 'react';
// import { Box, Typography, useTheme, Grid } from '@mui/material';
// import {
//   FaWheelchair,
//   FaComment,
//   FaHands,
//   FaUsers,
//   FaRestroom,
//   FaDeaf,
//   FaEye,
//   FaBrain,
//   FaChevronCircleDown
// } from 'react-icons/fa';
// import { SectionProps, CarePlanFieldPath } from '../../../../types/ndisSection/carePlanInfoTypes';
// import { CareTextField, SectionHeader } from '../Components';

// // Utility function to safely access nested properties
// const getNestedValue = (obj: any, path: string): string => {
//   if (!obj) return 'Not provided';
//   const keys = path.split('.');
//   let current = obj;
//   for (const key of keys) {
//     if (current && typeof current === 'object' && key in current) {
//       current = current[key];
//     } else {
//       return 'Not provided';
//     }
//   }
//   return current || 'Not provided';
// };

// const AbilitiesSection: React.FC<SectionProps> = ({
//   editMode,
//   isMobile,
//   handleEditToggle,
//   handleSubmit,
//   handleCancel,
//   control,
//   errors,
//   getValues,
//   carePlan
// }) => {
//   const theme = useTheme();
//   const spacing = isMobile ? 1 : 2;

//   const fields: { label: string; name: CarePlanFieldPath; icon: JSX.Element }[] = [
//     {
//       label: 'Mobility',
//       name: 'AbilitiesAndSupportNeeds.Mobility' as CarePlanFieldPath,
//       icon: <FaWheelchair />
//     },
//     {
//       label: 'Communication',
//       name: 'AbilitiesAndSupportNeeds.Communication' as CarePlanFieldPath,
//       icon: <FaComment />
//     },
//     {
//       label: 'Self Care',
//       name: 'AbilitiesAndSupportNeeds.SelfCare' as CarePlanFieldPath,
//       icon: <FaHands />
//     },
//     {
//       label: 'Social Interaction',
//       name: 'AbilitiesAndSupportNeeds.SocialInteraction' as CarePlanFieldPath,
//       icon: <FaUsers />
//     },
//     {
//       label: 'Support Needs',
//       name: 'AbilitiesAndSupportNeeds.SupportNeeds' as CarePlanFieldPath,
//       icon: <FaHands />
//     },
//     {
//       label: 'Continence',
//       name: 'AbilitiesAndSupportNeeds.Continence' as CarePlanFieldPath,
//       icon: <FaRestroom />
//     },
//     {
//       label: 'Hearing',
//       name: 'AbilitiesAndSupportNeeds.Hearing' as CarePlanFieldPath,
//       icon: <FaDeaf />
//     },
//     {
//       label: 'Vision',
//       name: 'AbilitiesAndSupportNeeds.Vision' as CarePlanFieldPath,
//       icon: <FaEye />
//     },
//     {
//       label: 'Cognition',
//       name: 'AbilitiesAndSupportNeeds.Cognition' as CarePlanFieldPath,
//       icon: <FaBrain />
//     },
//     {
//       label: 'Swallowing Difficulty',
//       name: 'AbilitiesAndSupportNeeds.SwallowingDifficulty' as CarePlanFieldPath,
//       icon: <FaChevronCircleDown />
//     }
//   ];

//   return (
//     <Box
//       sx={{
//         backgroundColor: theme.palette.background.paper,
//         borderRadius: 2,
//         boxShadow: theme.shadows[1],
//         overflow: 'hidden',
//         width: '100%',
//         maxWidth: '100%',
//         mx: 'auto'
//       }}
//     >
//       <SectionHeader
//         icon={<FaWheelchair size={isMobile ? 16 : 20} />}
//         title="Abilities & Support Needs"
//         color={theme.palette.secondary.main}
//         editMode={editMode}
//         handleEditToggle={handleEditToggle}
//         handleSubmit={handleSubmit}
//         handleCancel={handleCancel}
//         getValues={getValues}
//       />

//       <Box sx={{ p: isMobile ? 1 : 2 }}>
//         {editMode ? (
//           <Grid container spacing={spacing}>
//             {fields.map((field) => (
//               <Grid item xs={12} sm={6} key={field.name}>
//                 <CareTextField
//                   label={field.label}
//                   name={field.name}
//                   control={control}
//                   errors={errors}
//                   getValues={getValues}
//                   icon={React.cloneElement(field.icon, { size: isMobile ? 14 : 16 })}
//                   size={isMobile ? 'small' : 'medium'}
//                 />
//               </Grid>
//             ))}
//           </Grid>
//         ) : (
//           <Grid container spacing={spacing}>
//             {fields.map((field) => {
//               const value = getNestedValue(carePlan, field.name);
//               return (
//                 <Grid item xs={12} sm={6} key={field.name}>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       p: isMobile ? 1 : 1.5,
//                       backgroundColor: theme.palette.background.default,
//                       borderRadius: 1,
//                       height: '100%',
//                       minHeight: isMobile ? 56 : 64,
//                       transition: 'all 0.2s ease',
//                       '&:hover': {
//                         backgroundColor: theme.palette.action.hover
//                       }
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         backgroundColor: theme.palette.secondary.light,
//                         color: theme.palette.secondary.dark,
//                         borderRadius: '50%',
//                         width: isMobile ? 32 : 36,
//                         height: isMobile ? 32 : 36,
//                         flexShrink: 0
//                       }}
//                     >
//                       {React.cloneElement(field.icon, {
//                         size: isMobile ? 14 : 16
//                       })}
//                     </Box>
//                     <Box sx={{ overflow: 'hidden', flex: 1 }}>
//                       <Typography
//                         variant={isMobile ? 'caption' : 'subtitle2'}
//                         sx={{
//                           fontWeight: 500,
//                           color: theme.palette.text.secondary,
//                           lineHeight: 1.2
//                         }}
//                       >
//                         {field.label}
//                       </Typography>
//                       <Typography
//                         variant={isMobile ? 'body2' : 'body1'}
//                         sx={{
//                           fontWeight: 400,
//                           color: theme.palette.text.primary,
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           display: '-webkit-box',
//                           WebkitLineClamp: 2,
//                           WebkitBoxOrient: 'vertical'
//                         }}
//                       >
//                         {value}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Grid>
//               );
//             })}
//           </Grid>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default AbilitiesSection;


import React, { useState, useEffect } from 'react';
import { Box, Typography, useTheme, Grid, Button, IconButton, TextField } from '@mui/material';
import {
  FaWheelchair,
  FaComment,
  FaHands,
  FaUsers,
  FaRestroom,
  FaDeaf,
  FaEye,
  FaBrain,
  FaChevronCircleDown,
  FaPlus,
  FaTimes
} from 'react-icons/fa';
import { SectionProps } from '../../../../types/ndisSection/carePlanInfoTypes';
import { SectionHeader, CareTextField } from '../Components';

interface CustomField {
  id: string;
  label: string;
  value: string;
}

type AbilitiesFieldPath =
  | 'AbilitiesAndSupportNeeds.Mobility'
  | 'AbilitiesAndSupportNeeds.Communication'
  | 'AbilitiesAndSupportNeeds.SelfCare'
  | 'AbilitiesAndSupportNeeds.SocialInteraction'
  | 'AbilitiesAndSupportNeeds.SupportNeeds'
  | 'AbilitiesAndSupportNeeds.Continence'
  | 'AbilitiesAndSupportNeeds.Hearing'
  | 'AbilitiesAndSupportNeeds.Vision'
  | 'AbilitiesAndSupportNeeds.Cognition'
  | 'AbilitiesAndSupportNeeds.SwallowingDifficulty';

const AbilitiesSection: React.FC<SectionProps> = ({
  editMode,
  isMobile,
  handleEditToggle,
  handleSubmit,
  handleCancel,
  control,
  errors,
  getValues,
  setValue,
  carePlan
}) => {
  const theme = useTheme();
  const spacing = isMobile ? 1 : 2;

  // Initialize customFields from form data or empty array
  const initialCustomFields = () => {
    const customFieldsData = getValues('AbilitiesAndSupportNeeds.customFields');
    if (customFieldsData && typeof customFieldsData === 'object') {
      return Object.entries(customFieldsData).map(([label, value]) => ({
        id: `custom-${label}-${Date.now()}`,
        label,
        value: value as string
      }));
    }
    return [];
  };

  const [customFields, setCustomFields] = useState<CustomField[]>(initialCustomFields);
  const [newFieldLabel, setNewFieldLabel] = useState('');
  const [newFieldValue, setNewFieldValue] = useState('');
  const [showAddField, setShowAddField] = useState(false);

  const fields: { label: string; name: AbilitiesFieldPath; icon: JSX.Element }[] = [
    {
      label: 'Mobility',
      name: 'AbilitiesAndSupportNeeds.Mobility',
      icon: <FaWheelchair />
    },
    {
      label: 'Communication',
      name: 'AbilitiesAndSupportNeeds.Communication',
      icon: <FaComment />
    },
    {
      label: 'Self Care',
      name: 'AbilitiesAndSupportNeeds.SelfCare',
      icon: <FaHands />
    },
    {
      label: 'Social Interaction',
      name: 'AbilitiesAndSupportNeeds.SocialInteraction',
      icon: <FaUsers />
    },
    {
      label: 'Support Needs',
      name: 'AbilitiesAndSupportNeeds.SupportNeeds',
      icon: <FaHands />
    },
    {
      label: 'Continence',
      name: 'AbilitiesAndSupportNeeds.Continence',
      icon: <FaRestroom />
    },
    {
      label: 'Hearing',
      name: 'AbilitiesAndSupportNeeds.Hearing',
      icon: <FaDeaf />
    },
    {
      label: 'Vision',
      name: 'AbilitiesAndSupportNeeds.Vision',
      icon: <FaEye />
    },
    {
      label: 'Cognition',
      name: 'AbilitiesAndSupportNeeds.Cognition',
      icon: <FaBrain />
    },
    {
      label: 'Swallowing Difficulty',
      name: 'AbilitiesAndSupportNeeds.SwallowingDifficulty',
      icon: <FaChevronCircleDown />
    }
  ];

  // Update form data whenever customFields change
  useEffect(() => {
    const customFieldsObj = customFields.reduce((acc, field) => {
      acc[field.label] = field.value;
      return acc;
    }, {} as Record<string, string>);

    setValue('AbilitiesAndSupportNeeds.customFields', customFieldsObj, { shouldValidate: true });
  }, [customFields, setValue]);

  const addCustomField = () => {
    if (newFieldLabel.trim()) {
      const newField = {
        id: `custom-${Date.now()}`,
        label: newFieldLabel.trim(),
        value: newFieldValue.trim()
      };
      setCustomFields([...customFields, newField]);
      setNewFieldLabel('');
      setNewFieldValue('');
      setShowAddField(false);
    }
  };

  const removeCustomField = (id: string) => {
    setCustomFields(customFields.filter((field) => field.id !== id));
  };

  const updateCustomField = (id: string, value: string) => {
    setCustomFields(customFields.map((field) => (field.id === id ? { ...field, value } : field)));
  };

  // Helper function to safely get field values
  const getFieldValue = (fieldName: AbilitiesFieldPath): string => {
    try {
      const value = getValues(fieldName);
      return value || 'Not provided';
    } catch (error) {
      return 'Not provided';
    }
  };

  // Get custom fields from form data for view mode
  const getCustomFieldsFromData = () => {
    const customFieldsData = getValues('AbilitiesAndSupportNeeds.customFields');
    if (customFieldsData && typeof customFieldsData === 'object') {
      return Object.entries(customFieldsData).map(([label, value]) => ({
        id: `custom-${label}`,
        label,
        value: value as string
      }));
    }
    return [];
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
        overflow: 'hidden',
        width: '100%',
        maxWidth: '100%',
        mx: 'auto'
      }}
    >
      <SectionHeader
        icon={<FaWheelchair size={isMobile ? 16 : 20} />}
        title="Abilities & Support Needs"
        color={theme.palette.secondary.main}
        editMode={editMode}
        handleEditToggle={handleEditToggle}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        getValues={getValues}
      />

      <Box sx={{ p: isMobile ? 1 : 2 }}>
        {editMode ? (
          <Grid container spacing={spacing}>
            {fields.map((field) => (
              <Grid item xs={12} sm={6} key={field.name}>
                <CareTextField
                  label={field.label}
                  name={field.name}
                  control={control}
                  errors={errors}
                  getValues={getValues}
                  icon={React.cloneElement(field.icon, { size: isMobile ? 14 : 16 })}
                  size={isMobile ? 'small' : 'medium'}
                />
              </Grid>
            ))}

            {/* Render custom fields */}
            {customFields.map((field) => (
              <Grid item xs={12} sm={6} key={field.id}>
                <Box sx={{ position: 'relative' }}>
                  <TextField
                    fullWidth
                    label={field.label}
                    value={field.value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      updateCustomField(field.id, e.target.value)
                    }
                    size={isMobile ? 'small' : 'medium'}
                    InputProps={{
                      startAdornment: (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            mr: 1,
                            color: theme.palette.secondary.dark
                          }}
                        >
                          <FaPlus size={isMobile ? 14 : 16} />
                        </Box>
                      )
                    }}
                  />
                  <IconButton
                    size="small"
                    onClick={() => removeCustomField(field.id)}
                    sx={{
                      position: 'absolute',
                      right: -8,
                      top: -8,
                      backgroundColor: theme.palette.error.main,
                      color: theme.palette.error.contrastText,
                      '&:hover': {
                        backgroundColor: theme.palette.error.dark
                      }
                    }}
                  >
                    <FaTimes size={12} />
                  </IconButton>
                </Box>
              </Grid>
            ))}

            {/* Add new field form */}
            {showAddField ? (
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                  <TextField
                    fullWidth
                    label="Custom Field Label"
                    value={newFieldLabel}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setNewFieldLabel(e.target.value)
                    }
                    size={isMobile ? 'small' : 'medium'}
                  />
                  <TextField
                    fullWidth
                    label="Custom Field Value"
                    value={newFieldValue}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setNewFieldValue(e.target.value)
                    }
                    size={isMobile ? 'small' : 'medium'}
                  />
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={addCustomField}
                      disabled={!newFieldLabel.trim()}
                    >
                      Add Field
                    </Button>
                    <Button
                      variant="outlined"
                      color="secondary"
                      size="small"
                      onClick={() => {
                        setNewFieldLabel('');
                        setNewFieldValue('');
                        setShowAddField(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Button
                  variant="outlined"
                  startIcon={<FaPlus />}
                  onClick={() => setShowAddField(true)}
                  size={isMobile ? 'small' : 'medium'}
                  sx={{ mt: 1 }}
                >
                  Add Custom Field
                </Button>
              </Grid>
            )}
          </Grid>
        ) : (
          <Grid container spacing={spacing}>
            {fields.map((field) => (
              <Grid item xs={12} sm={6} key={field.name}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    p: isMobile ? 1 : 1.5,
                    backgroundColor: theme.palette.background.default,
                    borderRadius: 1,
                    height: '100%',
                    minHeight: isMobile ? 56 : 64,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: theme.palette.action.hover
                    }
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: theme.palette.secondary.light,
                      color: theme.palette.secondary.dark,
                      borderRadius: '50%',
                      width: isMobile ? 32 : 36,
                      height: isMobile ? 32 : 36,
                      flexShrink: 0
                    }}
                  >
                    {React.cloneElement(field.icon, {
                      size: isMobile ? 14 : 16
                    })}
                  </Box>
                  <Box sx={{ overflow: 'hidden', flex: 1 }}>
                    <Typography
                      variant={isMobile ? 'caption' : 'subtitle2'}
                      sx={{
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        lineHeight: 1.2
                      }}
                    >
                      {field.label}
                    </Typography>
                    <Typography
                      variant={isMobile ? 'body2' : 'body1'}
                      sx={{
                        fontWeight: 400,
                        color: theme.palette.text.primary,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical'
                      }}
                    >
                      {getFieldValue(field.name)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}

            {/* Display custom fields in view mode */}
            {getCustomFieldsFromData().map((field) => (
              <Grid item xs={12} sm={6} key={field.id}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    p: isMobile ? 1 : 1.5,
                    backgroundColor: theme.palette.background.default,
                    borderRadius: 1,
                    height: '100%',
                    minHeight: isMobile ? 56 : 64,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: theme.palette.action.hover
                    }
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: theme.palette.secondary.light,
                      color: theme.palette.secondary.dark,
                      borderRadius: '50%',
                      width: isMobile ? 32 : 36,
                      height: isMobile ? 32 : 36,
                      flexShrink: 0
                    }}
                  >
                    <FaPlus size={isMobile ? 14 : 16} />
                  </Box>
                  <Box sx={{ overflow: 'hidden', flex: 1 }}>
                    <Typography
                      variant={isMobile ? 'caption' : 'subtitle2'}
                      sx={{
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        lineHeight: 1.2
                      }}
                    >
                      {field.label}
                    </Typography>
                    <Typography
                      variant={isMobile ? 'body2' : 'body1'}
                      sx={{
                        fontWeight: 400,
                        color: theme.palette.text.primary,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical'
                      }}
                    >
                      {field.value || 'Not provided'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default AbilitiesSection;